export interface AnimeEpisode {
  id: string;
  animeId: string;
  number: number;
  title: string;
  thumbnail: string;
  duration: string;
  publishDate: string;
}

export interface AnimeItem {
  id: string;
  title: string;
  slug: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  subCategory: string;
  year: number;
  season: string;
  rating: number;
  episodes: number;
  status: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateDay: string;
  views: number;
  episodesList: AnimeEpisode[];
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '日漫', slug: 'japanese' },
  { name: '国漫', slug: 'chinese' },
  { name: '剧场版', slug: 'movie' },
  { name: '热血', slug: 'action' },
  { name: '搞笑', slug: 'comedy' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
];

export const animeList: AnimeItem[] = [
  {
    id: '1',
    title: '咒术回战 第二季',
    slug: 'jujutsu-kaisen-s2',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20Jujutsu%20Kaisen%20style%20dark%20fantasy%20action%20anime%20with%20dynamic%20characters%20in%20combat%20poses%2C%20vibrant%20energy%20effects%2C%20dramatic%20lighting%2C%20clean%20illustration%20style%20on%20dark%20background%20with%20minimal%20text%20overlay%2C%20high%20quality%20anime%20poster%20design&width=600&height=800&seq=anime-cover-01&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    subCategory: '热血',
    year: 2023,
    season: '夏',
    rating: 9.2,
    episodes: 23,
    status: '已完结',
    description: '虎杖悠仁在吞下宿傩的手指后，成为了两面宿傩的容器。为了收集所有宿傩的手指并将其消灭，他加入了东京都立咒术高等专门学校，与伏黑惠、钉崎野蔷薇等伙伴一起，踏上了成为咒术师的修行之路。第二季将讲述怀玉篇和涩谷事变篇的精彩故事。',
    tags: ['热血', '战斗', '校园', '黑暗奇幻'],
    isHot: true,
    isNew: false,
    updateDay: '周四',
    views: 8920000,
    episodesList: [
      { id: 'e1-1', animeId: '1', number: 1, title: '怀玉', thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20screenshot%20style%20with%20two%20characters%20standing%20in%20traditional%20Japanese%20school%20setting%2C%20warm%20afternoon%20lighting%2C%20emotional%20atmosphere%2C%20clean%20anime%20art%20style%20subdued%20colors&width=480&height=270&seq=ep-thumb-01-01&orientation=landscape', duration: '24:10', publishDate: '2023-07-06' },
      { id: 'e1-2', animeId: '1', number: 2, title: '怀玉-贰', thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20battle%20scene%20with%20energy%20effects%20in%20urban%20setting%20at%20dusk%2C%20two%20figures%20facing%20off%2C%20dramatic%20composition%2C%20anime%20art%20style%20with%20vibrant%20blue%20energy&width=480&height=270&seq=ep-thumb-01-02&orientation=landscape', duration: '24:05', publishDate: '2023-07-13' },
    ],
  },
  {
    id: '2',
    title: '葬送的芙莉莲',
    slug: 'frieren-beyond-journeys-end',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20fantasy%20adventure%20anime%20with%20elf%20mage%20character%20in%20flowing%20dress%20walking%20through%20beautiful%20meadow%20with%20soft%20pastel%20colors%2C%20gentle%20atmosphere%2C%20healing%20fantasy%20style%20on%20light%20background%20minimal%20text&width=600&height=800&seq=anime-cover-02&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    subCategory: '奇幻',
    year: 2023,
    season: '秋',
    rating: 9.5,
    episodes: 28,
    status: '连载中',
    description: '魔法使芙莉莲与勇者辛美尔等人一起，经历了十年的冒险后打败了魔王，为世界带来了和平。作为寿命远超人类的精灵，她对于同伴的衰老与死亡感到困惑与悲伤。为了了解人类，芙莉莲踏上了新的旅程。',
    tags: ['奇幻', '冒险', '治愈', '成长'],
    isHot: true,
    isNew: true,
    updateDay: '周五',
    views: 7560000,
    episodesList: [
      { id: 'e2-1', animeId: '2', number: 1, title: '冒险的终点', thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20fantasy%20adventurers%20celebrating%20victory%20in%20royal%20castle%20courtyard%2C%20warm%20golden%20sunset%20light%2C%20emotional%20healing%20atmosphere%2C%20soft%20anime%20art%20style&width=480&height=270&seq=ep-thumb-02-01&orientation=landscape', duration: '24:20', publishDate: '2023-09-29' },
    ],
  },
  {
    id: '3',
    title: '鬼灭之刃 柱训练篇',
    slug: 'demon-slayer-hashira-training',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20demon%20slayer%20style%20action%20anime%20with%20sword-wielding%20characters%20in%20traditional%20Japanese%20uniform%2C%20intense%20expressions%2C%20dramatic%20fire%20and%20water%20effects%2C%20dark%20background%20with%20traditional%20patterns%2C%20high%20quality%20anime%20poster&width=600&height=800&seq=anime-cover-03&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    subCategory: '热血',
    year: 2024,
    season: '春',
    rating: 9.0,
    episodes: 8,
    status: '已完结',
    description: '为了迎接与鬼舞辻无惨的最终决战，炭治郎和同伴们前往各个柱的身边，接受严苛的训练。在这过程中，每个人都将突破自己的极限，为最终的战斗做好准备。',
    tags: ['热血', '战斗', '历史', '鬼怪'],
    isHot: true,
    isNew: false,
    updateDay: '周日',
    views: 10200000,
    episodesList: [
      { id: 'e3-1', animeId: '3', number: 1, title: '为了打倒鬼舞辻无惨', thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20training%20scene%20with%20sword%20practice%20in%20traditional%20Japanese%20dojo%2C%20morning%20light%20streaming%20through%20windows%2C%20intense%20atmosphere%2C%20anime%20art%20style%20with%20warm%20earth%20tones&width=480&height=270&seq=ep-thumb-03-01&orientation=landscape', duration: '47:10', publishDate: '2024-05-12' },
    ],
  },
  {
    id: '4',
    title: '完美世界',
    slug: 'perfect-world',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20key%20visual%20of%20cultivation%20fantasy%20with%20heroic%20male%20character%20in%20flowing%20ancient%20Chinese%20robes%2C%20surrounded%20by%20mystical%20energy%20and%20ancient%20runes%2C%20epic%20landscape%20background%20with%20mountains%20and%20clouds%2C%203D%20CG%20anime%20style&width=600&height=800&seq=anime-cover-04&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    subCategory: '奇幻',
    year: 2021,
    season: '全年',
    rating: 8.8,
    episodes: 182,
    status: '连载中',
    description: '一粒尘可填海，一根草斩尽日月星辰。石昊自幼被夺走至尊骨，在逆境中崛起，凭借自身的天赋与毅力，一步步走向巅峰，成为万古唯一的荒天帝。',
    tags: ['玄幻', '修仙', '战斗', '国漫'],
    isHot: false,
    isNew: false,
    updateDay: '周三',
    views: 5680000,
    episodesList: [
      { id: 'e4-1', animeId: '4', number: 182, title: '天命已至', thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20epic%20battle%20scene%20with%20divine%20characters%20clashing%20in%20celestial%20realm%2C%20golden%20energy%20effects%2C%20ancient%20Chinese%20architecture%20in%20background%2C%203D%20CG%20animation%20style&width=480&height=270&seq=ep-thumb-04-01&orientation=landscape', duration: '20:05', publishDate: '2025-08-06' },
    ],
  },
  {
    id: '5',
    title: '间谍过家家 第二季',
    slug: 'spy-x-family-s2',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20comedy%20spy%20family%20anime%20with%20three%20characters%20in%20stylish%20outfits%20posing%20playfully%2C%20elegant%20European%20city%20background%2C%20warm%20and%20humorous%20atmosphere%2C%20clean%20illustration%20style%20with%20vibrant%20but%20soft%20colors&width=600&height=800&seq=anime-cover-05&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    subCategory: '搞笑',
    year: 2023,
    season: '秋',
    rating: 9.1,
    episodes: 12,
    status: '已完结',
    description: '为了执行任务，西国最强间谍"黄昏"组建了一个临时家庭。妻子约尔是杀手，女儿阿尼亚是超能力者。三人互相隐藏身份，却在这虚假的家庭中找到了真正的温暖。',
    tags: ['搞笑', '日常', '间谍', '家庭'],
    isHot: false,
    isNew: false,
    updateDay: '周六',
    views: 6450000,
    episodesList: [
      { id: 'e5-1', animeId: '5', number: 1, title: '跟踪爸爸与妈妈', thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20comedy%20scene%20of%20family%20in%20European%20city%20street%2C%20bright%20sunny%20day%2C%20playful%20and%20warm%20atmosphere%2C%20anime%20art%20style%20with%20soft%20pastel%20colors&width=480&height=270&seq=ep-thumb-05-01&orientation=landscape', duration: '24:00', publishDate: '2023-10-07' },
    ],
  },
  {
    id: '6',
    title: '斗破苍穹',
    slug: 'battle-through-the-heavens',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20key%20visual%20with%20young%20male%20protagonist%20holding%20flaming%20sword%2C%20ancient%20Chinese%20fantasy%20setting%2C%20epic%20battle%20stance%2C%20phoenix%20fire%20effects%2C%203D%20CG%20anime%20style%20with%20dramatic%20lighting%20on%20dark%20background&width=600&height=800&seq=anime-cover-06&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    subCategory: '热血',
    year: 2017,
    season: '全年',
    rating: 8.5,
    episodes: 156,
    status: '连载中',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人。在机缘巧合之下，他从戒指中唤醒了药老，从此踏上逆袭之路，一步步走向斗气大陆的巅峰。',
    tags: ['玄幻', '热血', '国漫', '冒险'],
    isHot: false,
    isNew: false,
    updateDay: '周日',
    views: 4230000,
    episodesList: [
      { id: 'e6-1', animeId: '6', number: 156, title: '决战云岚宗', thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20epic%20sect%20battle%20with%20multiple%20cultivators%20flying%20in%20sky%2C%20mountainous%20landscape%2C%20golden%20and%20crimson%20energy%20clashes%2C%203D%20CG%20style%20with%20dramatic%20composition&width=480&height=270&seq=ep-thumb-06-01&orientation=landscape', duration: '22:30', publishDate: '2025-08-10' },
    ],
  },
  {
    id: '7',
    title: '我推的孩子',
    slug: 'oshi-no-ko',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20idol%20and%20showbiz%20drama%20anime%20with%20beautiful%20female%20character%20in%20stage%20costume%20under%20spotlight%2C%20star%20effects%2C%20glamorous%20yet%20mysterious%20atmosphere%2C%20elegant%20anime%20illustration%20style%20with%20vibrant%20pink%20and%20purple&width=600&height=800&seq=anime-cover-07&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    subCategory: '恋爱',
    year: 2023,
    season: '春',
    rating: 8.9,
    episodes: 11,
    status: '已完结',
    description: '当红偶像星野爱怀孕后秘密生下双胞胎，粉丝医生吾郎转生为她的孩子。在娱乐圈的光鲜亮丽背后，隐藏着不为人知的黑暗与真相。一场关于爱与复仇的故事就此展开。',
    tags: ['偶像', '悬疑', '转生', '娱乐圈'],
    isHot: false,
    isNew: false,
    updateDay: '周三',
    views: 5340000,
    episodesList: [
      { id: 'e7-1', animeId: '7', number: 1, title: 'Mother and Children', thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20hospital%20room%20with%20newborn%20babies%20and%20mysterious%20atmosphere%2C%20subdued%20lighting%2C%20emotional%20and%20dramatic%20mood%2C%20anime%20art%20style%20with%20soft%20shadows&width=480&height=270&seq=ep-thumb-07-01&orientation=landscape', duration: '24:30', publishDate: '2023-04-12' },
    ],
  },
  {
    id: '8',
    title: '凡人修仙传',
    slug: 'a-record-of-a-mortals-journey',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20key%20visual%20of%20cultivation%20journey%20with%20protagonist%20in%20humble%20robes%20gradually%20transforming%2C%20ancient%20Chinese%20landscape%20with%20immortal%20mountains%20and%20waterfalls%2C%20mystical%20mist%2C%203D%20CG%20anime%20style%20with%20realistic%20lighting&width=600&height=800&seq=anime-cover-08&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    subCategory: '奇幻',
    year: 2020,
    season: '全年',
    rating: 9.0,
    episodes: 92,
    status: '连载中',
    description: '一个普通的山村穷小子韩立，偶然之下跨入一个江湖小门派。虽然资质平庸，但依靠自身努力和合理算计，最终修炼成仙。这是一个凡人一步步走向巅峰的传奇故事。',
    tags: ['修仙', '国漫', '奇幻', '冒险'],
    isHot: false,
    isNew: true,
    updateDay: '周六',
    views: 3890000,
    episodesList: [
      { id: 'e8-1', animeId: '8', number: 92, title: '星海飞驰', thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20scene%20of%20cultivator%20flying%20through%20starry%20sky%2C%20cosmic%20dust%20and%20celestial%20phenomena%2C%202D%20and%203D%20hybrid%20animation%20style%20with%20deep%20space%20colors&width=480&height=270&seq=ep-thumb-08-01&orientation=landscape', duration: '20:15', publishDate: '2025-08-09' },
    ],
  },
];

export const heroBanners = [
  {
    id: 'b1',
    title: '咒术回战 第二季',
    description: '怀玉篇·涩谷事变篇震撼来袭！史上最强战斗场面，带你感受咒术世界的极致魅力！',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20multiple%20characters%20using%20supernatural%20powers%20in%20urban%20cityscape%20at%20night%2C%20dramatic%20energy%20effects%20in%20cyan%20and%20crimson%2C%20cinematic%20composition%2C%20high%20quality%20anime%20art%20style%20with%20dark%20atmospheric%20lighting%2C%20wide%20landscape%20poster&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
    link: '/article/1',
    badge: '热播中',
  },
  {
    id: 'b2',
    title: '葬送的芙莉莲',
    description: '治愈系奇幻巅峰之作，跨越时间的感动，每一帧都是壁纸级别的精美画面！',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20fantasy%20landscape%20with%20elf%20character%20walking%20through%20flowering%20meadow%20under%20golden%20sunset%20sky%2C%20soft%20pastel%20colors%2C%20healing%20and%20peaceful%20atmosphere%2C%20cinematic%20wide%20shot%20anime%20art%20style%20with%20warm%20glowing%20light&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
    link: '/article/2',
    badge: '强烈推荐',
  },
  {
    id: 'b3',
    title: '完美世界',
    description: '国漫之光！一粒尘可填海，一根草斩尽日月星辰，见证荒天帝的崛起之路！',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20epic%20fantasy%20with%20heroic%20figure%20standing%20atop%20mountain%20peak%20surrounded%20by%20celestial%20phenomena%2C%20ancient%20Chinese%20aesthetic%20with%20floating%20islands%20and%20waterfalls%2C%20golden%20and%20jade%20colors%2C%203D%20CG%20cinematic%20wide%20shot&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
    link: '/article/4',
    badge: '国漫精选',
  },
];

export const faqData = [
  {
    question: '奶泡动漫需要注册会员才能观看吗？',
    answer: '不需要！奶泡动漫所有番剧资源完全免费观看，无需注册会员，打开即看，让每一位动漫爱好者都能无障碍享受追番乐趣。',
  },
  {
    question: '支持哪些设备观看动漫？',
    answer: '奶泡动漫支持多端播放，包括电脑端、平板端和手机端。无论你是在家使用大屏电脑，还是通勤途中使用手机，都能随时随地畅享高清动漫体验。',
  },
  {
    question: '动漫更新速度快吗？',
    answer: '我们拥有专业的内容团队，新番上线后会第一时间更新，通常在日本播出后的数小时内即可在奶泡动漫观看到最新话。国漫方面也会同步各大平台的更新节奏。',
  },
  {
    question: '支持的最高画质是多少？',
    answer: '奶泡动漫全站支持1080P高清画质播放，部分热门番剧更提供4K超清画质选项。我们采用先进的视频编码技术，在保证清晰度的同时优化流量消耗。',
  },
  {
    question: '如何找到想看的动漫？',
    answer: '你可以通过首页的分类导航快速筛选日漫、国漫等类型，也可以使用搜索功能（即将上线）直接搜索番剧名称。热门推荐和最新更新模块也会帮你发现优质内容。',
  },
];

export const aboutStats = [
  { label: '收录番剧', value: '12,000+' },
  { label: '总集数', value: '30万+' },
  { label: '日活跃用户', value: '50万+' },
  { label: '累计播放', value: '10亿+' },
];